"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipItemSchema = exports.deleteMembershipResponseSchema = exports.deleteMembershipParamsSchema = exports.getMembershipDetailsResponseSchema = exports.getMembershipDetailsParamsSchema = exports.listMembershipsResponseSchema = exports.listMembershipsQuerySchema = exports.MembershipEntitySchema = exports.MerchantRoleSchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("../base/common.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// INTERNAL SCHEMAS (Entity)
// ============================================
// Merchant-specific roles (from user_merchants.role column)
const _MerchantRoleSchema = zod_1.z.enum(['member', 'staff', 'admin']);
// User-merchant membership schema
const _MembershipBaseSchema = zod_1.z.object({
    user_merchant_id: zod_1.z.number().int().positive(),
    user_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    role: _MerchantRoleSchema.default('member'),
    is_active: zod_1.z.boolean().default(true),
    created_at: timestamp_schemas_1.timestampIsoSchema,
    updated_at: timestamp_schemas_1.timestampIsoSchema,
});
// ============================================
// ENTITY SCHEMAS (Export Aliases)
// ============================================
exports.MerchantRoleSchema = _MerchantRoleSchema;
exports.MembershipEntitySchema = _MembershipBaseSchema;
// ============================================
// CUSTOMER MEMBERSHIP API SCHEMAS
// ============================================
// Internal: Membership item
const _MembershipItemSchema = zod_1.z.object({
    user_merchant_id: zod_1.z.number().int(),
    merchant_id: zod_1.z.number().int(),
    merchant_name: zod_1.z.string(),
    logo_url: zod_1.z.string().url().nullable(),
    role: exports.MerchantRoleSchema,
    member_since: timestamp_schemas_1.timestampIsoSchema,
    // Balances for display in Profile (FR166)
    credit_balance: common_schemas_1.moneyAmountSchema,
    available_points: zod_1.z.number().int().min(0),
    pending_points: zod_1.z.number().int().min(0),
    coupon_count: zod_1.z.number().int().min(0), // Active coupons from this merchant
});
// GET /memberships - Query (no filters needed for MVP)
exports.listMembershipsQuerySchema = zod_1.z.object({});
// GET /memberships - Response
exports.listMembershipsResponseSchema = (0, api_schemas_1.listResponseSchema)(_MembershipItemSchema);
// GET /memberships/:merchantId - Params
exports.getMembershipDetailsParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// GET /memberships/:merchantId - Response
exports.getMembershipDetailsResponseSchema = (0, api_schemas_1.dataResponseSchema)(_MembershipItemSchema);
// DELETE /memberships/:merchantId - Leave merchant
//
// IMPORTANT BUSINESS RULES (FR168-174):
// - Returns 400 if credit_balance > 0 (FR169) - cannot leave with money
// - Forfeits all points (available AND pending) (FR170)
// - Forfeits all unused coupons from this merchant (FR171)
// - Frontend should show warning dialog first (FR172)
// - Action is logged in audit log (FR174)
// - User can rejoin later as new member (FR173)
//
exports.deleteMembershipParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// DELETE /memberships/:merchantId - Response includes what was forfeited
exports.deleteMembershipResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    success: zod_1.z.boolean(),
    forfeited: zod_1.z.object({
        points_available: zod_1.z.number().int(),
        points_pending: zod_1.z.number().int(),
        coupons_count: zod_1.z.number().int(),
    }),
}));
// Export for reuse
exports.MembershipItemSchema = _MembershipItemSchema;
